export default "__VITE_ASSET__483af42e__"